var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('CardText',[_c('VText',{attrs:{"gutter-bottom":""}},[_vm._v("Connect your Google Analytics 4 to connect your profile and website\n      data.")])],1),_vm._v(" "),_c('CardActions',{attrs:{"align":"center","direction":"column"}},[_c('Button',{on:{"click":_vm.authorize}},[_vm._v("Connect Google Account")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }